import makeStyles from '@mui/styles/makeStyles'
import { tokens } from '../../styles/tokens'

export const useStyles = makeStyles(theme => ({
  clientInformationDialogHeader: {
    width: '100%',
    height: 60,
    borderRadius: '16px 16px 0 0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    justifyContent: 'center',
  },
  clientContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    height: '65px',
    width: '550px',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  commodityContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    height: '100px',
    width: '550px',
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  selectionContainer: {
    borderRadius: '12px',
    border: `1px solid ${tokens.color.neutral[200]}`,
    boxShadow: 'none',
    width: '550px',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  currencyTotal: {
    height: '50px',
    width: '550px',
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  violationCommentContainer: {
    width: '550px',
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  investment: {
    height: '110px',
    width: '550px',
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  clientPersonalInfoContainer: {
    width: '100%',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
  },
  clientPortfolioContainer: {
    height: '100%',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  topContainer: {
    width: '100%',
    height: '50%',
    display: 'flex',
    flexDirection: 'row',
  },
  iconSize: {
    height: '25px',
    width: '45px',
    lineHeight: '25px',
    fontSize: '12px',
  },
  position: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  topLineText: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  topLineIsin: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  topLineSeparator: {
    flexGrow: 1,
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    width: '100%',
    height: '50%',
    alignItems: 'flex-end',
  },
  securityInfo: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  percentage: {
    color: theme.palette.success.main,
  },
  boldText: {
    fontWeight: 'bold',
  },
  textColor: {
    color: theme.palette.primary.main,
  },
  clientIcon: {
    height: '40px',
    width: '40px',
  },
  clientCredentials: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
  clientPhone: {
    marginTop: theme.spacing(1),
  },
  actionButtons: {
    width: '100%',
  },
  totalsContainer: {
    height: '100%',
  },
  centerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  isin: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  halfWidth: {
    height: '100%',
    width: '50%',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: theme.spacing(1),
  },
  textWhite: {
    color: theme.palette.secondary.main,
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  textSeparatorLeft: {
    marginLeft: theme.spacing(1),
  },
  alignSelfToEnd: {
    alignSelf: 'flex-end',
  },
  flexGrow: {
    flexGrow: 1,
  },
  textToEnd: {
    textAlign: 'end',
  },
  flexRow90: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%',
    flexGrow: 1,
  },
  leftContent: {
    justifyContent: 'left',
    alignItems: 'left',
    paddingLeft: '10px',
    flexGrow: 1,
  },
  smallFont: {
    fontSize: '10px',
  },
  smallFontRed: {
    fontSize: '10px',
    fontWeight: 600,
    color: tokens.color.error[500],
  },
  fullwidth: {
    width: '100%',
  },
}))
